import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-print-wheel-popup',
    templateUrl: './print-wheel-popup.component.html',
    styleUrls: ['./print-wheel-popup.component.css'],
    standalone: false
})
export class PrintWheelPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
